"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncludesQueryBuilder = void 0;
const helpers_1 = require("../helpers");
/**
 * Builder to build AxiosRequestConfig 'include' params
 * for the `/accounting/account/<accountId>/users/clients` endpoint
 */
class IncludesQueryBuilder {
    constructor() {
        this.queryParams = {
            'include[]': [],
        };
    }
    includes(key) {
        this.queryParams = Object.assign(Object.assign({}, this.queryParams), { 'include[]': this.queryParams['include[]'].concat(key) });
        return this;
    }
    build(resourceType) {
        return (0, helpers_1.buildQueryString)(this.queryParams);
    }
}
exports.IncludesQueryBuilder = IncludesQueryBuilder;
//# sourceMappingURL=IncludesQueryBuilder.js.map